import React, { useState } from 'react';
import css from './CommonCards.module.css';
import { NamedLink } from '../../../../components';
import FarmingVegetables from '../../../../assets/cesta hortalizas.jpg';
import agricultora from '../../../../assets/agricultor.jpg';

/* -------------------- DATA -------------------- */
const cardsData = [
  {
    id: 1,
    image: FarmingVegetables,
    overlayText: '¿Qué es BioCerca?',

    backTitle: '¿Qué es BioCerca?',
    backSubtitle: 'Una pista... y una promesa: no volverás a comprar igual.',

    backContent: [
      'Estamos creando algo que puede transformar la forma en la que conectamos con quienes cultivan lo que comemos.',
      'Los agricultores cada vez ganan menos. Los consumidores pagan cada vez más.',
      'Y en medio, un sistema lleno de intermediarios que no beneficia a nadie.',
    ],

    backHeading: '¿Y si hubiera otra forma?',
    backFooterText: 'Una forma más justa, más cercana, más humana.',

    ctaText: 'Descúbrelo aquí ',
    ctaNote: 'si quieres ser de las primeras personas en vivirlo desde dentro',
  },
  {
    id: 2,
    image: agricultora,
    overlayText: 'BioCerca para agricultores',

    backTitle: 'BioCerca para agricultores',
    backContent: [
      '¿Te has cansado de vender por debajo del coste?',
      '¿De ver cómo los productos que con tanto esfuerzo cultivas acaban descartados por “feos”?',
      '¿De depender de cadenas que se quedan con casi todo… mientras tú solo sostienes la tierra?',
      'En BioCerca eso se acabó.',
    ],
    ctaText: 'Descúbrelo aquí',
    ctaNote:". Aquí vendes directo. Sin comisiones abusivas. Sin condiciones imposibles."

  },
];

/* -------------------- FLIP CARD -------------------- */
const FlipCard = ({ card, activeCardId, setActiveCardId }) => {
  const isFlipped = activeCardId === card.id;

  return (
    <div className={`${css.flipCard} ${isFlipped ? css.flipped : ''}`}>
      <div className={css.flipInner}>
        {/* FRONT */}
        <div className={css.flipFront}>
          <img src={card.image} alt={card.overlayText} />

          <div className={css.overlay}>
            <h3>{card.overlayText}</h3>
            <button className={css.tapButton} onClick={() => setActiveCardId(card.id)}>
              Toca aquí
            </button>
          </div>
        </div>

        {/* BACK */}
        <div className={css.flipBack}>
          <div className={css.cardWhite}>
            <h3>{card.backTitle}</h3>

            {card.backSubtitle && <p className={css.subtitle}>{card.backSubtitle}</p>}

            {card.backContent?.map((text, index) => (
              <p key={index}>{text}</p>
            ))}

            {card.backHeading && <h4 className={css.highlight}>{card.backHeading}</h4>}

            {card.backFooterText && <p>{card.backFooterText}</p>}

            {card.ctaText && (
              <NamedLink name="SignupPage" className={css.infoButton}>
                {card.ctaText}
              </NamedLink>
            )}

            {card.ctaNote && <span className={css.infoNote}>{card.ctaNote}</span>}
          </div>
          <button className={css.tapButton} onClick={() => setActiveCardId(null)}>
            Volver
          </button>
        </div>
      </div>
    </div>
  );
};

/* -------------------- PAGE -------------------- */
const CommonCards = () => {
  const [activeCardId, setActiveCardId] = useState(null);

  return (
    <section className={`${css.section} ${css.infoSection}`}>
      <div className={css.infoContainer}>
        {/* CARDS */}
        <div className={css.cardBlock}>
          {cardsData.map(card => (
            <FlipCard
              key={card.id}
              card={card}
              activeCardId={activeCardId}
              setActiveCardId={setActiveCardId}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommonCards;
